/**
 * @generated SignedSource<<e279bd7379164579fa032e6034e3dbab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AlertVoxpopmeVideoAnalysis_user$data = {
  readonly dId: any | null;
  readonly id: string;
  readonly vpmUserId: number | null;
  readonly " $fragmentType": "AlertVoxpopmeVideoAnalysis_user";
};
export type AlertVoxpopmeVideoAnalysis_user$key = {
  readonly " $data"?: AlertVoxpopmeVideoAnalysis_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"AlertVoxpopmeVideoAnalysis_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AlertVoxpopmeVideoAnalysis_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vpmUserId",
      "storageKey": null
    }
  ],
  "type": "UserNode",
  "abstractKey": null
};

(node as any).hash = "c777b0ce9ce02e540dd5904054e7bf7d";

export default node;
